export default __webpack_public_path__ + "assets/webgl/aim_target.b83242aa.bin";